export default {
  name: "GridContextMenu",
  props: {
    contextMenuList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {};
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  beforeDestroy() {
    this.$el.remove();
  },
  render(h) {
    return (
      <a-card class="grid-context-menu" tabindex="-1">
        <a-list
          data-source={this.contextMenuList}
          scopedSlots={{
            renderItem: (data) => {
              return (<a-list-item class="grid-context-menu-item" nativeOnClick={() => {
                data?.OnClick();
                this.$el.blur();
              }}>
                {data.Desc}
              </a-list-item>);
            }
          }}
        />
      </a-card>
    );
  }
}